import React from 'react';

import { Button } from '@mui/material';
import { Plus } from 'lucide-react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  button: {
    '&:hover': {
      backgroundColor: theme.appColors.hoverBackground,
    },
    borderRadius: 8,
    color: theme.appColors.primary,
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'none',
    width: '100%',
  },
}));

interface PlaybookAddButtonProps {
  children: string;
  onClick: () => void;
  dataCy?: string;
  disabled?: boolean;
}

/** Full-width text button used under a playbook list to add the next item. */
export function PlaybookAddButton({
  children,
  dataCy,
  disabled,
  onClick,
}: PlaybookAddButtonProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <Button
      className={classes.button}
      data-cy={dataCy}
      disabled={disabled}
      size="small"
      startIcon={<Plus size={18} />}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}
